"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SystemError = function (_Component) {
  _inherits(SystemError, _Component);

  function SystemError() {
    _classCallCheck(this, SystemError);

    return _possibleConstructorReturn(this, (SystemError.__proto__ || Object.getPrototypeOf(SystemError)).apply(this, arguments));
  }

  _createClass(SystemError, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "nav-menu" },
          _react2.default.createElement(
            "div",
            { className: "nav_logo" },
            _react2.default.createElement(
              "a",
              { href: "#" },
              _react2.default.createElement("img", { height: "81", src: "/asset/logo.png" })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { style: { textAlign: 'center' } },
          _react2.default.createElement("img", { className: "error_img", src: "/asset/500.jpg", width: "80%", height: "auto" })
        )
      );
    }
  }]);

  return SystemError;
}(_react.Component);

exports.default = SystemError;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SystemError.js
 ** module id = 809
 ** module chunks = 0
 **/